class RequestTracker {
  constructor() {
    this.activeRequests = new Set(); // Track request IDs instead of a counter
    this.requestId = 0;
    this.isRequestInProgress = false;
    this.completionCallbacks = new Set();
    this.statusCallbacks = new Set();
  }

  generateRequestId() {
    return `request_${++this.requestId}`;
  }

  addRequest() {
    const requestId = this.generateRequestId();
    this.activeRequests.add(requestId);
    this.updateStatus();
    return requestId;
  }

  removeRequest(requestId) {
    this.activeRequests.delete(requestId);
    this.updateStatus();
  }

  updateStatus() {
    const previousStatus = this.isRequestInProgress;
    this.isRequestInProgress = this.activeRequests.size > 0;

    // Notify status subscribers
    this.statusCallbacks.forEach((callback) =>
      callback({
        isLoading: this.isRequestInProgress,
        activeRequestCount: this.activeRequests.size,
      })
    );

    // Notify completion subscribers only when transitioning from active to complete
    if (previousStatus && !this.isRequestInProgress) {
      this.completionCallbacks.forEach((callback) => callback());
    }
  }

  subscribeToStatus(callback) {
    this.statusCallbacks.add(callback);
    return () => this.statusCallbacks.delete(callback);
  }

  subscribeToCompletion(callback) {
    this.completionCallbacks.add(callback);
    return () => this.completionCallbacks.delete(callback);
  }

  getStatus() {
    return {
      isLoading: this.isRequestInProgress,
      activeRequestCount: this.activeRequests.size,
    };
  }
}

const requestTracker = new RequestTracker();

export const subscribeToRequestStatus =
  requestTracker.subscribeToStatus.bind(requestTracker);
export const subscribeToCompletion =
  requestTracker.subscribeToCompletion.bind(requestTracker);
export const getRequestStatus = requestTracker.getStatus.bind(requestTracker);

export default requestTracker;
